import React, {Fragment, useContext} from "react";
import {ApiUtility} from "../common/ApiUtility";
import {Constants} from "../common/Constants";
import {useModelCreateEngine} from "../common/hooks/useModelCreateEngine";
import {ConditionalRenderer} from "../common/ConditionalRenderer";
import {OverlayLoadingIndicator} from "../common/OverlayLoadingIndicator";
import {ActivityScopeForm} from "./ActivityScopeForm";
import {GlobalContext} from "../admin-frame/AdminFrame";

export let CreateActivityScopePage = function () {
    const context = useContext(GlobalContext);
    const scopesListPath = `/${Constants.routes.settings.pathSegment}/activity-scopes`;
    const modelCreateEngine = useModelCreateEngine(
        ApiUtility.createActivityScope,
        'scope',
        () => context.navigator.navigateTo(scopesListPath)
    );

    return (
        <Fragment>
            <ConditionalRenderer if={modelCreateEngine.dataStore.data().loading} renderer={() => (
                <OverlayLoadingIndicator/>
            )}/>
            <ActivityScopeForm
                save={modelCreateEngine.createModel}
                isNew={true}
            />
        </Fragment>
    );
};
